<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">

        <div class="card mb-4">
          <div class="card-header pb-0">
            <h4>Lista Pesate</h4>
            <button type="button" id="add-btn" class="btn btn-primary" @click="clear" data-bs-toggle="modal" data-bs-target="#formModal">+ Nuovo</button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <custom-table ref="table$" :rows="data" @action="runAction" :columns="[
                 {
                    title: 'Data',
                    type: 'date',
                    data: 'date',
                },
                {
                    title: 'Peso',
                    type: 'text',
                    data: 'weight',
                    render: (row) => row.weight + ' kg'
                },
            ]" :actions="[
                {
                    title: 'Modifica',
                    tooltip: 'edit',
                    key: 'edit',
                },
            ]" 
              :pagination="pagination"
              @page-changed="handlePageChange"
              @update-pagination="handlePaginationUpdate"
              @search-changed="handleSearchChange"
            />
        </div>


      </div>
    </div>
  </div>

    <div class="modal fade" id="formModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="add" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="formModalBtn">Aggiungi nuovo peso</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="color: black;"></button>
          </div>
          <div class="modal-body">
            <Vueform ref="form$" v-model="weight" sync>
              <HiddenElement name="id" />
              <TextElement name="weight" label="Peso" rules="required|integer"></TextElement>
              <DateElement name="date" label="Data" rules="required"></DateElement>
            </Vueform>

          </div>
          <div class="modal-footer">
            <button type="button" id="close" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
            <button type="button" class="btn btn-primary" :class="{ loading: loading }"  @click="save">Salva</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import {horsesWeightService} from "@/services/HorsesWeightService";
import CustomTable from "@/components/CustomTable";
import { useToast } from "vue-toastification";
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useTableData } from "../../composables/useTableData";
const toast = useToast();

export default {
  name: "HorseWeights",
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      weight: {},
    };
  },
  setup(){
    return useTableData(
        horsesWeightService.getHorseWeights.bind(horsesWeightService),
        10
    );
  },
  mounted(){
    this.fetchData({horse_id: this.id});
  },
  computed: {
  },
  components: {
    CustomTable
  },
  methods: {
    async runAction({action, row}){
      this.loading = true;
      if(action.key == 'edit'){
        horsesWeightService.getHorseWeightsById(row.id).then((weight) => {
          this.weight = weight;
          this.loading=false;
          const modalElement = document.getElementById('formModal');
          const myModal = new bootstrap.Modal(modalElement);
          myModal.show();
        });
      }
    },
    clear(){
      this.weight = {};
      this.$refs.form$.reset();
    },
    created() {
    this.$store.dispatch('updateBreadcrumbs', [
      { title: 'Lista Cavalli', name: 'Horses' },
      { title: 'Cavallo', name: 'Horse', params: { id: this.id } }
    ]);
  },
    async save(){
      const form = this.$refs.form$;
      form.validate();
      if(this.weight.id) form.data.id = this.weight.id;
      form.data.horse_id = this.id;
      if (!form.hasErrors) {
        this.loading=true;
        try{
          await horsesWeightService.saveHorseWeight(form.data);
          toast(this.$t('operation_saved'));
          document.getElementById('close').click();
          this.fetchData({horse_id: this.id});
        }finally{
          this.loading=false;
        }
      }
    },
  },
};
</script>
